module.exports = __webpack_public_path__ + "img/stresa_hero_bg.067d58ae.png";